const SECOND = 1000

export const PROGRAM_OPTIONS_TIMEOUT = 25 * SECOND
